<template>
  <form v-show="modal"  @submit.prevent="createContactSubmit" class="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{$t("contacts.new_contact")}}</h5>
        <!--begin::Close-->
        <div class="modal-icon-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
            </svg>
          </span>
          <!--end::Svg Icon-->
        </div>
        <!--end::Close-->
      </div>
        <div class="modal-body">
          <div class="form">

            <!-- Avatar + type de contact -->
            <div class="d-flex align-items-start gap-6 mb-6">
              <div class="avatar-picker flex-shrink-0 mt-2 ms-2 me-2">
                <div
                  class="avatar-picker-circle w-90px h-90px"
                  :style="{backgroundImage: 'url(' + avatarDisplayUrl +')'}"
                  @click="$refs.avatarFileInput.click()"
                >
                  <i class="bi bi-camera-fill avatar-picker-hint"></i>
                </div>
                <input ref="avatarFileInput" v-on:change="onFileChange" type="file" name="avatar" accept=".png, .jpg, .jpeg" class="d-none" />
                <span v-if="hasCustomAvatar" class="btn btn-icon avatar-action-icon avatar-action-remove" @click="removeAvatar" title="Remove avatar">
                  <i class="bi bi-x fs-8"></i>
                </span>
              </div>

              <div class="flex-grow-1">
                <div class="d-flex flex-wrap align-items-center gap-6">
                  <div class="form-check form-check-custom form-check-solid">
                    <input :id="'society'+id" class="form-check-input" v-model="contactCreate.contactType" value="society" required type="radio" />
                    <label class="form-check-label fw-semibold" :for="'society'+id">{{$t("contacts.detail.society")}}</label>
                  </div>
                  <div class="form-check form-check-custom form-check-solid">
                    <input :id="'particular'+id" class="form-check-input" v-model="contactCreate.contactType" value="particular" required type="radio" />
                    <label class="form-check-label fw-semibold" :for="'particular'+id">{{$t("contacts.detail.particular")}}</label>
                  </div>
                  <div class="vr d-none d-sm-block"></div>
                  <div class="form-check form-switch form-check-custom form-check-solid ms-3">
                    <input :id="'customer'+id" class="form-check-input" v-model="contactCreate.customer" type="checkbox" />
                    <label class="form-check-label" :for="'customer'+id">{{$t("contacts.customer")}}</label>
                  </div>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input :id="'supplier'+id" class="form-check-input" v-model="contactCreate.supplier" type="checkbox" />
                    <label class="form-check-label" :for="'supplier'+id">{{ $t('contacts.supplier') }}</label>
                  </div>
                </div>

                <div class="row g-4 mt-1">
                  <div class="col-md-4" v-if="contactCreate.contactType === 'particular'">
                    <label class="required fs-7 fw-bold text-gray-700 mb-1">{{$t('user.gender')}}</label>
                    <select required name="gender" class="form-select form-select-solid kt_select2"
                            v-model="contactCreate.gender"  data-control="select2"
                            :data-dropdown-parent="'#contactCreateModal'"
                            data-search="true"
                            :data-placeholder="$t('user.civility')" >
                      <option value="female">{{ $t('user.female') }}</option>
                      <option value="male">{{ $t('user.male') }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="required fs-7 fw-bold text-gray-700 mb-1">{{ $t("contacts.lastname") }}</label>
                    <input type="text" v-model="contactCreate.lastname" class="form-control form-control-solid" :placeholder="contactLastNamePlaceholder" required>
                  </div>
                  <div class="col-md-4" v-if="contactCreate.contactType === 'particular'">
                    <label class="required fs-7 fw-bold text-gray-700 mb-1">{{ $t("contacts.firstname") }}</label>
                    <input type="text" v-model="contactCreate.firstname" class="form-control form-control-solid" :placeholder="$t('contacts.firstname')" required>
                  </div>
                  <div class="col-md-4" v-if="false && contactCreate.contactType == 'particular'">
                    <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.birthday")}}</label>
                    <input v-model="contactCreate.birthday" class="form-control form-control-solid" id="kt_hbd"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="separator separator-dashed my-6"></div>

            <!-- Coordonnées -->
            <h6 class="fw-bold text-gray-800 mb-4">{{ $t('contacts.detail.contact_info') }}</h6>
            <div class="row g-4">
              <div class="col-md-4">
                <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.detail.phone")}}</label>
                <InputTel
                  :name="'contactPhone'+id"
                  containerClass=""
                  v-model:phone="contactCreate.telephone"
                  v-model:phoneCode="contactCreate.phoneCode"
                  :placeholder="$t('contacts.detail.phone')"
                  :isRequired="false"
                />
              </div>
              <div class="col-md-4">
                <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.detail.email")}}</label>
                <input v-model="contactCreate.email" class="form-control form-control-solid"/>
              </div>
              <div class="col-md-4">
                <label class="fs-7 fw-bold text-gray-700 mb-1">{{$t("contacts.detail.website_link")}}</label>
                <input v-model="contactCreate.website" class="form-control form-control-solid" :placeholder="$t('contacts.placeholder.website')" type="url"/>
              </div>
            </div>

            <div class="separator separator-dashed my-6"></div>

            <!-- Adresse -->
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h6 class="fw-bold text-gray-800 mb-0">{{$t("contacts.detail.address")}}</h6>
              <div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" v-model="showAddress" :id="'showAddress'+id"/>
                <label class="form-check-label" :for="'showAddress'+id"></label>
              </div>
            </div>
            <div v-if="showAddress" class="row g-4">
              <div class="col-md-6">
                <input v-model="contactCreate.address.street" :placeholder="$t('contacts.placeholder.street')" type="text" class="form-control form-control-solid">
              </div>
              <div class="col-md-6">
                <input type="text" v-model="contactCreate.address.street2" :placeholder="$t('contacts.placeholder.street2')" class="form-control form-control-solid">
              </div>
              <div class="col-md-4">
                <select data-dropdown-parent="#contactCreateModal" data-search="true" :id="'country'+id" :name="'country'+id" :data-placeholder="$t('auth.country')" class="form-select form-select-solid " data-control="select2" v-model="contactCreate.address.country">
                  <option></option>
                  <option v-for="country in getCountries" :key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
              </div>
              <Select2
                  :parent-id="'#'+parentId"
                  containerClass="col-md-4"
                  :name="'contactAddressCity'"
                  :multiple="false"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :placeholderText="$t('contacts.placeholder.city')"
                  v-model="contactCreate.address.city">
                <option v-for="city in cites" :key="city.id" :value="city.id">
                  {{ city.name }}
                </option>
              </Select2>
              <div class="col-md-4">
                <input type="text" v-model="contactCreate.address.zipcode" class="form-control form-control-solid" :placeholder="$t('contacts.placeholder.zipcode')">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
          <button type="submit" id="kt_submit_create_contact" class="btn btn-sm btn-primary fw-bolder">
            <span class="indicator-label">{{ $t('button.save') }}</span>
            <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
          </button>
        </div>
    </div>
  </form>
</template>

<script>
    import { Settings } from 'luxon'
    import { mapGetters ,mapActions } from 'vuex'
    import {BASE_IMAGE_URL} from "@/services/api";
    import Select2 from "@/components/Select2.vue";
    import InputTel from "@/components/InputTel.vue";
    export default {
      components: {Select2, InputTel},

        props: {
            contact: {type: Object, required: true},
            getCountries: {type: Array, required: false},
            modal: {type: Boolean, default: false},
            edit: {type: Boolean, default: false},
            id: {type: String, default:"1" },
            parentId: {type: String, default:"contactCreateModal" }
        },

        data(){
            return {
                email: null,
                showAddress: false,
                contactCreate : {
                    id : null,
                    gender : null,
                    contactType: 'particular',
                    lastname: null,
                    firstname: null,
                    address: {
                      street: null,
                      street2: null,
                      city: null,
                      zipcode: null,
                      country: null
                    },
                    customer: true,
                    birthday: null,
                    supplier: false,
                    telephone: null,
                    phoneCode: null,
                    previewAvatar : BASE_IMAGE_URL +'/assets/img_default.jpg',
                    email:null,
                    website: null
              }}
        },

        watch: {
            '$i18n.locale': function(value){
                Settings.defaultLocale = value
            },
            contact: function(value){
              this.contactCreate = value
              this.showAddress = !!(value?.address && (value.address.street || value.address.street2 || value.address.city || value.address.zipcode || value.address.country))
            },
          'contactCreate.contactType': function (value) {
            if (value) {
              this.$nextTick(() => {
                this.initSelect2()
                this.contactCreate.firstname = null
                this.contactCreate.gender = null

              })
            }
          },
        },

        mounted(){
          this.loadCities()
            this.contactCreate = this.contact
            this.showAddress = !!(this.contact?.address && (this.contact.address.street || this.contact.address.street2 || this.contact.address.city || this.contact.address.zipcode || this.contact.address.country))
            Settings.defaultLocale = localStorage.getItem('locale')

          let today = new Date() ;
          let yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          $("#kt_hbd").flatpickr({
            dateFormat: "d-m-Y",
            maxDate: yesterday
          });

          KTImageInput.init();
          this.initSelect2()
        },

        computed: {
            contactLastNamePlaceholder(){
                if(this.contactCreate.contactType == 'particular'){
                    return i18n.global.t('contacts.lastname')
                }else{
                    return i18n.global.t('contacts.society_name')
                }
            },

            particular(){
                return this.contactCreate.contactType == 'particular'
            },

            avatarDisplayUrl(){
                if (this.contactCreate.previewAvatar instanceof File) {
                    return URL.createObjectURL(this.contactCreate.previewAvatar)
                }
                return this.contactCreate.previewAvatar
            },

            hasCustomAvatar(){
                if (this.contactCreate.previewAvatar instanceof File) return true
                const url = this.contactCreate.previewAvatar || ''
                return !!url && !url.includes('img_default.jpg') && !url.includes('blank.png')
            },
          ...mapGetters('cities', [
            'getCities'
          ]),

          cites () {
              if(this.contactCreate.address.country)
                return this.getCities.filter(el => el.country_id == this.contactCreate.address.country)

              return this.getCities
          }
        },

        methods: {
          ...mapActions('cities', [
            'loadCities'
          ]),
          ...mapActions('contacts', [
            'createContact',
            'uploadAvatar',
            'updateContact'
          ]),

          initSelect2() {
            KTApp.initSelect2()
            $('#country'+ this.id).select2()

            $('body select[data-control="select2"]').select2()

            $('body select[data-control="select2"]').change((e) => {
              switch (e.target.name) {
                case 'country'+this.id :
                  this.contactCreate.address.country = e.target.value
                  break;
                case 'gender':
                  this.contactCreate.gender = e.target.value
                  break;
              }
            });

          },
          onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if (!files[0]) return;
            this.contactCreate.previewAvatar = files[0];
          },
          removeAvatar() {
            this.contactCreate.previewAvatar = BASE_IMAGE_URL + '/assets/img_default.jpg'
            if (this.$refs.avatarFileInput) this.$refs.avatarFileInput.value = ''
          },
            pad(s) {
                return (s < 10) ? '0' + s : s;
            },

            convertDate(d) {
                return [d.getFullYear(), this.pad(d.getMonth()+1), this.pad(d.getDate()),].join('-')
            },

            timeZone(){
                return Intl.DateTimeFormat().resolvedOptions().timeZone
            },

            async createContactSubmit(){
            this.$loading('kt_submit_create_contact')
            let response = {}
            try{
              const payload = {
                ...this.contactCreate,
                telephone: this.contactCreate.telephone ? [this.contactCreate.telephone] : []
              }
              if(this.edit){
                response = await this.updateContact(payload)
              }else{
                response = await this.createContact(payload)
              }

              if (response.data.contact) {
                if (this.contactCreate.previewAvatar && this.contactCreate.previewAvatar instanceof File) {
                  let avatarData = new FormData()
                  avatarData.append('avatar', this.contactCreate.previewAvatar);
                  avatarData.append('contact_id', response.data.contact.id);
                  await this.uploadAvatar(avatarData)
                }
                this.$emit('success', response.data.contact)
                this.$emit('selectContact', response.data.contact.id)

                $('#contactCreateModal').modal('toggle')
                this.contactCreate = {
                  id : null,
                  gender : null,
                  contactType: 'particular',
                  name: null,
                  address: {
                    street: null,
                    street2: null,
                    city: null,
                    zipcode: null,
                    country: null
                  },
                  customer: true,
                  birthday: null,
                  supplier: false,
                  telephone: null,
                  phoneCode: null,
                  previewAvatar: '',
                  email:null,
                  website: null
                },
                  this.showAddress = false
                  window.toastr['success'](i18n.global.t('notification.contact_created'))

                this.$stopLoading('kt_submit_create_contact')
                return true
              }
            }catch(e){
              this.$stopLoading('kt_submit_create_contact')
            }
          },
        },


    }
</script>

<style scoped>

    .avatar-picker {
        position: relative;
        display: inline-block;
    }

    .avatar-picker-circle {
        border-radius: 10px;
        background-color: #f5f8fa;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border: 1px dashed #d9d9e3;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }

    .avatar-picker-hint {
        color: #fff;
        font-size: 11px;
        background: rgba(0, 0, 0, 0.45);
        border-radius: 50%;
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 4px;
    }

    .avatar-action-icon {
        padding: 0 !important;
        width: auto !important;
        height: auto !important;
        min-width: 0 !important;
        color: #fff !important;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));
    }

    .avatar-action-remove {
        position: absolute;
        top: -2px;
        right: -2px;
        cursor: pointer;
    }
    .avatar-action-remove i {
        color: #f1416c !important;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));
    }

    .theme-orange .vdatetime-popup__header,
    .theme-orange .vdatetime-calendar__month__day--selected > span > span,
    .theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
        background: #1e1e2d;
    }

    .theme-orange .vdatetime-year-picker__item--selected,
    .theme-orange .vdatetime-time-picker__item--selected,
    .theme-orange .vdatetime-popup__actions__button {
        color: #1e1e2d;
    }
</style>
